// Pulls just the #hashtags out of a caption, e.g.
// "Bridal suit #phulkari, love it #wedding!" -> ["phulkari", "wedding"]
export function extractHashtags(caption) {
  if (!caption) return [];

  const matches = caption.match(/#[a-zA-Z0-9_]+/g) || [];
  return [...new Set(matches.map(tag => tag.slice(1).toLowerCase()))];
}

// One-time upgrade path for posts made before title/description/hashtags were
// merged into a single caption: folds the old separate fields into one string
// so editing an old post doesn't lose its description or hashtags.
export function buildLegacyCaption(design) {
  let caption = design.title || "";

  if (design.description) {
    caption = caption ? `${caption}\n\n${design.description}` : design.description;
  }

  const lower = caption.toLowerCase();
  const missingTags = (design.hashtags || []).filter(tag => !lower.includes(`#${tag}`));

  if (missingTags.length > 0) {
    const tagLine = missingTags.map(tag => `#${tag}`).join(" ");
    caption = caption ? `${caption}\n\n${tagLine}` : tagLine;
  }

  return caption;
}
